"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
let XcPluginHooks = class XcPluginHooks {
    async appStart() {}
    async projectStart() {}
    async projectStop() {}
    async projectDelete() {}
    async syncMigrations() {}
};
const _default = XcPluginHooks;
